import privateRoutes from "./private-routes";

export type RetiredRouteRedirect = { from: string; to: string };

/**
 * Paths whose pages were removed. They are not in `privateRoutes` any more, so the literals live here.
 * Each is matched by prefix, so subpaths and query strings (`/accept-payment/verification?key=2`) redirect too.
 */
export const RETIRED_ROUTE_REDIRECTS: ReadonlyArray<RetiredRouteRedirect> = [
  { from: "/accept-payment/setup", to: privateRoutes.acceptPayment.path },
  { from: "/accept-payment/verification", to: privateRoutes.acceptPayment.path }
];
